import React, { useEffect, useState } from "react";
import CostaMain from "../../Components/CostaMain/CostaMain";
import "./Contacts.css";
import { useSelector } from "react-redux";

const Contacts = () => {
  const [contactInfo, setContactInfo] = useState([]);
  const channelGuid = useSelector((state) => state.channel.channelGuid);

  console.log(contactInfo);

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await fetch("/contacts/standardContacts.json");
        const data = await response.json();

        const contacts = data.filter((contact) => {
          return contact.channelGuid === channelGuid;
        });
        contacts.push(
          data.find((contact) => contact.channelGuid === "default")
        );

        setContactInfo(contacts);
      } catch (error) {
        console.error("Errore nel recupero delle info:", error);
      }
    };

    if (channelGuid) {
      fetchContacts();
    }
  }, [channelGuid]);

  return (
    <CostaMain isColumn={true}>
      {contactInfo &&
        contactInfo.map((contact, index) => {
          return (
            <div
              className={`panel w-100 h-100 d-flex flex-column justify-content-center ${
                index !== 0 ? "mt-3" : ""
              }`}
            >
              <div className="contacts-header col-md-12">
                <h4>{contact.channel}</h4>
              </div>
              <div className="d-flex w-50 flex-row">
                <div
                  className="thumbnail"
                  style={{
                    backgroundImage: `url(${
                      contact.avatarUrl || "/assets/default-man.png"
                    })`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    width: "160px",
                    height: "200px",
                  }}
                ></div>

                <div className="flex-grow-1">
                  <h5 className="info">
                    <b>{contact.firstName}</b>
                    <br />
                    {contact.channelGuid !== "default" && (
                      <>
                        <b>{contact.lastName}</b>
                        <br />
                      </>
                    )}
                    <small>{contact.company}</small>
                  </h5>
                  <address>
                    <a href={contact.mail} className="text-decoration-none">
                      {contact.mail}
                    </a>
                  </address>
                </div>
              </div>
            </div>
          );
        })}
    </CostaMain>
  );
};

export default Contacts;
